import { useState } from 'react';
import { X, MessageCircle, Phone } from 'lucide-react';
import { BUSINESS_INFO } from '../data';
import { useLang } from '../context/LangContext';

export default function FloatingCTA() {
  const [open, setOpen] = useState(false);
  const { t } = useLang();

  const options = [
    {
      label: 'WhatsApp',
      sub: '+39 329 425 8480',
      icon: '💬',
      color: '#25D366',
      href: `https://wa.me/${BUSINESS_INFO.whatsappRaw}?text=${encodeURIComponent('Hi! I found Isha Boutique online and would love to know more about your collection 🌸')}`,
    },
    {
      label: 'Messenger',
      sub: 'Facebook Chat',
      icon: '📨',
      color: '#0084FF',
      href: BUSINESS_INFO.messenger,
    },
    {
      label: 'Facebook',
      sub: 'View our page',
      icon: '👗',
      color: '#1877F2',
      href: BUSINESS_INFO.facebook,
    },
    {
      label: 'Call Us',
      sub: BUSINESS_INFO.phone,
      icon: '📞',
      color: 'var(--accent)',
      href: `tel:${BUSINESS_INFO.phoneRaw}`,
    },
  ];

  return (
    <div style={{ position: 'fixed', bottom: '0.5rem', right: '0.5rem', zIndex: 200, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
      {/* Option bubbles */}
      <div style={{
        display: 'flex', flexDirection: 'column', gap: '0.6rem',
        marginBottom: '0.75rem', alignItems: 'flex-end',
        opacity: open ? 1 : 0,
        transform: open ? 'translateY(0)' : 'translateY(10px)',
        pointerEvents: open ? 'auto' : 'none',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
      }}>
        {options.map((opt, i) => (
          <a
            key={opt.label}
            href={opt.href}
            target="_blank"
            rel="noopener noreferrer"
            className="glass"
            style={{
              display: 'flex', alignItems: 'center', gap: '0.75rem',
              padding: '0.7rem 1.25rem',
              borderRadius: '50px',
              textDecoration: 'none', color: 'var(--text)',
              transition: 'all 0.3s cubic-bezier(0.25,1,0.5,1)',
              animationDelay: `${i * 0.05}s`,
              transform: open ? 'translateX(0)' : 'translateX(20px)',
            }}
            onMouseOver={e => {
              e.currentTarget.style.borderColor = opt.color;
              e.currentTarget.style.transform = 'translateX(-4px)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.22)';
              e.currentTarget.style.transform = 'translateX(0)';
            }}
          >
            <span style={{ fontSize: '1.1rem' }}>{opt.icon}</span>
            <span>
              <div style={{ fontSize: '0.82rem', fontWeight: 700 }}>{opt.label}</div>
              <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)' }}>{opt.sub}</div>
            </span>
          </a>
        ))}
      </div>

      {/* Main FAB button */}
      <button
        onClick={() => setOpen(o => !o)}
        aria-label={open ? 'Close contact menu' : 'Contact us'}
        className="animate-pulse-ring"
        style={{
          width: '42px', height: '42px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, var(--accent), #C47F89)',
          border: 'none', cursor: 'pointer', color: '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 8px 30px rgba(183,110,121,0.45)',
          transition: 'transform 0.3s cubic-bezier(0.25,1,0.5,1), box-shadow 0.3s',
          transform: open ? 'rotate(45deg) scale(1.05)' : 'rotate(0) scale(1)',
        }}
      >
        {open ? <X size={18} /> : <MessageCircle size={18} />}
      </button>
    </div>
  );
}
